import { defineNuxtPlugin } from '#app';
import { Range } from 'vue-range-multi';
import 'vue-range-multi/style.css';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('MRange', Range);
});
